import React, { Component } from 'react';
import CollectionBanner from './../collectionBanner';
import {Stories} from './../../utils/stories';
import Slider from "react-slick";
import "./collectionBrowser.css";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state={};
  }
  beforeChange = (current, next) =>{
    this.setState({
      current:next,
      previous:current,
      scrollActivated:true
    })
  }
  render() {
    let settings ={};
    if(window.outerWidth < 800){
      settings = {
        speed: 500,
        arrows:true,
        slidesToShow: 1,
      }
    } else{
      settings = {
        infinite: true,
        speed: 500,
        arrows:true
      }
    }
    settings["afterChange"] = this.afterChange
    settings["beforeChange"] = this.beforeChange

    return(
      <Slider className={"full-height full-width light-grey-background collection-slider relative"} {...settings}>
        {Stories.map((story, i) => {
          let transitionClass = "";
          let forceToBottom = false;
          if(i == this.state.current){
            transitionClass = 'slick-transition-current';
          }
          if(i == this.state.previous){
            transitionClass = 'slick-transition-previous';
          }
          if(i == 0 && !this.state.scrollActivated){
            transitionClass = 'slick-transition-current';
          }
          if(story.subtitle == "Cuba"){
            forceToBottom = true;
          }
          return (
            <CollectionBanner
              transitionClass={transitionClass}
              mobileOptimize={true}
              forceToBottom={forceToBottom}
              image={story.backgroundImage}
              title={story.title}
              link={story.link} />
          );
        })}
      </Slider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/collectionBrowser/index.js